import { EmployeeContactUser } from './../../../shared/employee-contact';
import { CustomizeHomePageService } from './../../customize-homepage/customize-homepage.service';
import { EmployeeServices } from './../../employees/services/employee.services';
import { UserService } from './../../users/services/user.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { Observable } from 'rxjs';
import { BusinessView } from '../models/';
import { EmployeeCourse } from './../../employees/models/employeeCourse';
import { EmployeeCourseServices } from './../../employees/services/employeecourse.service';
import { AbsenceCode } from './../models/businessAbsence';
import { BusinessEquipment } from './../models/businessEquipmentType';
import { BusinessAgreement } from './../models/businessList';
import { BusinessServices } from './business.services';
import { BusinessAbsenceService } from './businessAbsenceService';
import { BusinessCategoryService } from './businessCategory.service';
import { BusinessEquipmentService } from './businessEquipment.service';
import { BusinessSettingService } from './businessSetting.service';
import { BusinessLogService } from './businessLog.service';
import { UserRole } from '../../follow-ups/models/deviation';
@Injectable()
export class HomePageEditResolver {
  constructor(private backend: CustomizeHomePageService) {}
  resolve(): Observable<any[]> {
    return this.backend.getData(
      BaseServices.ApplicationId,
      45,
      BaseServices.UserId
    );
  }
}

@Injectable()
export class BusinessEditResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.params['bid']);
  }
}

@Injectable()
export class BusinessDetailsChildResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.parent.params['bid']);
  }
}

@Injectable()
export class BusinessAgreementResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getAgreementByBusinessId(+route.parent?.params['bid']);
  }
}

@Injectable()
export class BusinessEquipmentResolver {
  constructor(private backend: BusinessEquipmentService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.list(+route.parent?.params['bid']);
  }
}
@Injectable()
export class BusinessCourseResolverByBusiness
{
  constructor(private backend: EmployeeCourseServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.list(+route.parent!.params['bid']);
  }
}

@Injectable()
export class BusinessCourseEditResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.params['eid']);
  }
}

@Injectable()
export class BusinessContractEditResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.params['eid']);
  }
}

@Injectable()
export class BusinessAbsenceCodeByBusinessResolver
{
  constructor(private backend: BusinessAbsenceService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getAbsenceById(+route.parent?.params['bid']);
  }
}

@Injectable()
export class UserDropDownResolver {
  constructor(private backend: BusinessSettingService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getEmployee(BaseServices.BusinessId);
  }
}
@Injectable()
export class UserDropDownResolverForBusiness {
  constructor(private backend: BusinessSettingService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getEmployee(+route.parent?.params['bid']);
  }
}

@Injectable()
export class LanguageResolver {
  constructor(private backend: BusinessSettingService) {}
  resolve() {
    return this.backend.getLanguage();
  }
}

@Injectable()
export class SettingByBusinessResolver {
  constructor(private backend: BusinessSettingService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getSettingsByBusinessId(+route.parent?.params['bid']);
  }
}

@Injectable()
export class UserByBusinessResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getUsersByBusiness(+route.parent?.params['bid']);
  }
}
@Injectable()
export class EmployeeContactUserResolver
{
  constructor(private backend: UserService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<EmployeeContactUser[]> {
    return this.backend.getEmployeeContactUsers(+route.parent.params['bid']);
  }
}

@Injectable()
export class EmployeeOnlyResolver {
  constructor(private backend: UserService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<EmployeeContactUser[]> {
    return this.backend.getEmployeeOnly(+route.parent.params['bid']);
  }
}

@Injectable()
export class HseManagerResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getHseManager(+route.parent?.params['bid']);
  }
}
@Injectable()
export class ContactsByBusinessResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getContactsByBusiness(+route.parent?.params['bid']);
  }
}
@Injectable()
export class HavePersonalDelegateResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getHpdOptions(+route.parent?.params['bid']);
  }
}

@Injectable()
export class BusinessCourseListResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    let url = route.url[0].path;
    let IsEmployeeCourse = false;
    if (url == 'contractlist') {
      IsEmployeeCourse = false;
    } else if (url == 'editContract') {
      IsEmployeeCourse = false;
    } else {
      IsEmployeeCourse = true;
    }
    return this.backend.getAllByCourseName(
      +route.parent?.params['bid'],
      IsEmployeeCourse
    );
  }
}
@Injectable()
export class BusinessUserEditResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getByUserId(+route.params['uid']);
  }
}
@Injectable()
export class BusinessCategoryResolver {
  constructor(private backend: BusinessCategoryService) {}
  resolve() {
    return this.backend.getAllCategories();
  }
}
@Injectable()
export class PortalContactListResolver {
  constructor(private backend: BusinessSettingService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getPortalContacts(BaseServices.UserId);
  }
}
@Injectable()
export class PortalBusinessResolver {
  constructor(private backend: BusinessSettingService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getPortalBusiness(+route.parent?.params['bid']);
  }
}

@Injectable()
export class BusinessLogListResolver {
  constructor(private backend: BusinessLogService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getAllLogs(+route.parent?.params['bid']);
  }
}
@Injectable()
export class EmployeeCountResolver {
  constructor(private backend: EmployeeServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      return this.backend.list(+route.params['bid']);
    } else {
      return this.backend.list(BaseServices.BusinessId);
    }
  }
}
@Injectable()
export class BusinessCacheResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    if (
      +BaseServices.roleId === UserRole.ADMIN ||
      +BaseServices.roleId === UserRole.PORTAL
    ) {
      return this.backend.list();
    } else {
      return null;
    }
  }
}
@Injectable()
export class BusinessCreatorResolver {
  constructor(private backend: BusinessServices) {}
  resolve(): Observable<any> {
    if (BaseServices.roleId === '2') {
      return null;
    }
    return this.backend.getBusinessCreator(BaseServices.BusinessId);
  }
}
@Injectable()
export class CompanyNameResolver {
  constructor(private backend: BusinessServices) {}
  resolve() {
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      // Use slower but feature-complete endpoint for components that need feature checking
      let res: any = this.backend.activeBusinesslist();
      return res;
    }
  }
}

@Injectable()
export class CompanyNameFastResolver {
  constructor(private backend: BusinessServices) {}
  resolve() {
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      // Use faster endpoint for admin and portal levels (activities only)
      let res: any = this.backend.getBusinessNames();
      return res;
    }
  }
}

@Injectable()
export class BusinessDepartmentResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (+BaseServices.roleId === UserRole.PORTAL) {
      return this.backend.portalBusinessDepartments(BaseServices.PortalId);
    } else {
      return this.backend.businessDepartments(BaseServices.BusinessId);
    }
  }
}

@Injectable()
export class BusinessDataResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.parent?.params['bid']);
  }
}

@Injectable()
export class BusinessDataFeatureResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.params['bid']);
  }
}

@Injectable()
export class LicenseCategoryResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getAllLicenseCategory();
  }
}
@Injectable()
export class RiskListResolver {
  constructor(private backend: BusinessServices) {}
  resolve(): Observable<any[]> {
    return this.backend.getPortalRiskAnalysis(BaseServices.UserId);
  }
}

@Injectable()
export class BusinessUsersCountResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getUsersCount(+route.parent?.params['bid']);
  }
}

@Injectable()
export class BusinessEmployeesCountResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getEmployeesCount(+route.parent?.params['bid']);
  }
}
